import { auth } from './firebase';

export const signIn = async (email, password) => {
  try {
    return await auth.signInWithEmailAndPassword(email, password);
  } catch (error) {
    console.error(error);
    return null;
  }
};